import { useMutation } from "@tanstack/react-query";
import { http } from "../../../../../../../services/HttpService";

export const useUpdatePaymentIntent = () => {
  return useMutation((dto) => http.post(`/stripe/update-payment-intent`, dto));
};
